export { default } from './accent-icon';
